import { Form } from 'formsy-semantic-ui-react';
import MyTypes from 'MyTypes';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Button, Grid } from 'semantic-ui-react';
import { accountActions } from '../../features/account';
import { NewUser } from '../../models/newUser';
import services from '../../services';
import * as datesHelper from '../../utils/datesHelper';
import AddLicenseModal from './../register-layout/AddLicenseModal';
import EditLicenseModal from './../register-layout/EditLicenseModal';
import LicenseItem from './../register-layout/LicenseItem';

interface Props {
  getSubmitRef: (ref: any) => void;
  changeRegisterStore: typeof accountActions.changeRegisterStore;
  changeProgressValue: typeof accountActions.changeProgressValue;
  newUser: NewUser;
  progress: number;
}

interface State {
  licenses: object[];
  licenseId: number | undefined;
  showEditModal: boolean;
}

class RegisterLicenses extends React.Component<Props, State> {
  public state = {
    licenses: [],
    licenseId: 0,
    showEditModal: false,
  };

  public sumbitRef = React.createRef();

  public downloadLocalFile = (file: any) => {
    services.api.file.downloadLocalFile(file);
  };

  public getLicense = (item: object, id?: number) => {
    const { licenses } = this.state;

    item.issuedDate = datesHelper.parseDateToDateStringWithFormat(item.issuedDate);
    item.expirationDate = datesHelper.parseDateToDateStringWithFormat(item.expirationDate);

    if (id === undefined) {
      licenses.push(item);
    } else {
      const index = licenses.findIndex(el => el.id === id);
      licenses[index] = item;
    }
    this.setState({ licenses });
  };

  public editLicenseData = (id: number, item: object) => {
    const licenses = [...this.state.licenses];
    const index = licenses.findIndex(el => el.id === id);
    licenses[index] = { ...item };
    this.setState({ licenses, showEditModal: false });
  };

  public deleteLicense = (id: number) => {
    const { licenses } = this.state;
    const index = licenses.findIndex(el => el.id === id);
    licenses.splice(index, 1);
    this.setState({ licenses });
  };

  public editLicense = (show: boolean, id?: number) => {
    if (id !== null) {
      this.setState({ licenseId: id });
    }
    this.setState({ showEditModal: show });
  };

  public componentDidMount() {
    this.props.getSubmitRef(this.sumbitRef);
    this.setState({
      licenses: this.props.newUser.licenses,
    });
  }

  public render() {
    return (
      <Grid stackable={true} style={{ width: '100%' }} className="licenses-grid">
        <Grid.Row columns={1} only="computer">
          <Grid.Column className="licenses-column">
            <Form
              onValidSubmit={(model: any) => {
                const { licenses } = this.state;
                const licensesBuff = licenses.map((el: any) => {
                  delete el.id;
                  return el;
                });
                console.log(licenses);
                licenses.length === 0
                  ? this.props.changeProgressValue(this.props.progress)
                  : this.props.changeProgressValue(this.props.progress + 11);
                this.props.changeRegisterStore({ licenses: licensesBuff });
              }}
            >
              {this.state.licenses.length === 0 ? (
                <Form.Input
                  name="licenses"
                  placeholder="Nothing Added"
                  instantValidation={false}
                  className="form-input readonly-input"
                  readOnly={true}
                />
              ) : (
                <div>
                  {this.state.licenses.map((el: any, index: number) => (
                    <LicenseItem
                      item={el}
                      key={index}
                      id={index}
                      editLicense={this.editLicense}
                      deleteLicense={this.deleteLicense}
                      mode="license"
                      download={this.downloadLocalFile}
                    />
                  ))}
                </div>
              )}
              <Form.Input
                name="licenseFile"
                hidden={true}
                style={{ display: 'none' }}
                readOnly={true}
              />
              <Button ref={this.sumbitRef} type="submit" style={{ display: 'none' }} />
            </Form>
            <div style={{ width: '100%' }}>
              <AddLicenseModal getLicense={this.getLicense} mode="license" />
            </div>
            <EditLicenseModal
              show={this.state.showEditModal}
              showModal={this.editLicense}
              editLicense={this.editLicenseData}
              item={this.state.licenses[this.state.licenseId]}
              mode="license"
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row columns={16} only="tablet mobile">
          <Grid.Column className="licenses-column">
            <Form
              onValidSubmit={(model: any) => {
                const { licenses } = this.state;
                const licensesBuff = licenses.map((el: any) => {
                  delete el.id;
                  return el;
                });
                licenses.length === 0
                  ? this.props.changeProgressValue(this.props.progress)
                  : this.props.changeProgressValue(this.props.progress + 11);
                this.props.changeRegisterStore({ licenses: licensesBuff });
              }}
            >
              {this.state.licenses.length === 0 ? (
                <Form.Input
                  name="licenses"
                  placeholder="Nothing Added"
                  instantValidation={false}
                  className="form-input readonly-input"
                  readOnly={true}
                />
              ) : (
                <div>
                  {this.state.licenses.map((el: any, index: number) => (
                    <LicenseItem
                      item={el}
                      key={index}
                      id={index}
                      editLicense={this.editLicense}
                      deleteLicense={this.deleteLicense}
                      mode="license"
                      download={this.downloadLocalFile}
                    />
                  ))}
                </div>
              )}
              <Form.Input
                name="licenseFile"
                hidden={true}
                style={{ display: 'none' }}
                readOnly={true}
              />
              <Button ref={this.sumbitRef} type="submit" style={{ display: 'none' }} />
            </Form>
            <div style={{ width: '100%' }}>
              <AddLicenseModal getLicense={this.getLicense} mode="license" />
            </div>
            <EditLicenseModal
              show={this.state.showEditModal}
              showModal={this.editLicense}
              editLicense={this.editLicenseData}
              item={this.state.licenses[this.state.licenseId]}
              mode="license"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
  newUser: state.account.register.newUser,
  progress: state.account.register.progress,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      changeRegisterStore: accountActions.changeRegisterStore,
      changeProgressValue: accountActions.changeProgressValue,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterLicenses);
